import { Box, Text } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
  paddingX: {
    base: '$16',
  },
});

export const ProductTitle = Text.withConfig({
  variant: 'headerTwo',
  margin: 0,
  numberOfLines: 1,
});

export const ProductDetailFlowHeaderContainer = Box.withConfig({
  width: 'full',
  height: '$16',
  justifyContent: 'center',
  alignItems: 'center',
});
